export default "__VITE_PUBLIC_ASSET__849d036a__"